<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="d-none" v-html="stringHtml"></div>
          <div class="header-elements align-items-center">
            <b-row class="mt-1">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5 class="mt-2">
                      <!-- <span v-if="orderPos==true">Order Detail</span>&nbsp; -->
                      <span
                        v-if="
                          Invoices.transaction_type == 'sales' &&
                            !transTypeDeposit &&
                            !transTypeCredit &&
                            !transTypeRefundNote &&
                            !orderPos
                        "
                        >Sale Invoice</span
                      >
                      <span
                        v-if="
                          Invoices.transaction_type == 'return' &&
                            !transTypeDeposit &&
                            !transTypeCredit &&
                            !transTypeRefundNote &&
                            !orderPos
                        "
                        >Return Invoice</span
                      >
                      <span v-if="transTypeDeposit || transTypeCredit">
                        <img
                          src="@/assets/images/big_tick.svg"
                          width="20"
                          alt
                        />
                        Payment Successful &nbsp;</span
                      >
                      <span
                        v-if="
                          orderPos &&
                            order_from == undefined &&
                            !transTypeDeposit
                        "
                      >
                        Order Details
                        <!-- {{
                          Invoices.order_status == "Cancelled"
                            ? "Cancelled"
                            : "Placed"
                        }} -->
                      </span>
                      <span v-if="orderPos && order_from == 'success'">
                        <img
                          src="@/assets/images/big_tick.svg"
                          width="20"
                          alt
                          class="mr-1"
                        />
                        Order Placed Successfully!
                      </span>
                      <span v-if="transTypeRefundNote">
                        <img
                          src="@/assets/images/big_tick.svg"
                          width="20"
                          alt
                          class="mr-1"
                        />
                        Credit Refund Successful!
                      </span>
                    </h5>
                  </b-col>
                  <b-col lg="5" md="5" class="text-right">
                    <router-link
                      v-bind:to="
                        transTypeDeposit ||
                        transTypeCredit ||
                        transTypeRefundNote
                          ? '/customer-list/' + depositData.customer.mobile
                          : '../invoices-history'
                      "
                      v-if="!orderPos"
                    >
                      <b-button
                        size="sm"
                        id="back-to-invoices"
                        variant="primary"
                        :disabled="$loading"
                        >Back to
                        {{
                          transTypeDeposit ||
                          transTypeCredit ||
                          transTypeRefundNote
                            ? "Customer"
                            : "Invoices"
                        }}</b-button
                      >
                    </router-link>
                    <b-dropdown
                      size="sm"
                      right
                      variant="light"
                      class="invoice-options"
                      text="Invoice Options"
                      v-show="Invoices.transaction_type == 'sales' && !orderPos"
                    >
                      <b-dropdown-item
                        variant="dark"
                        class="fs-13"
                        @click="returnItems"
                        :disabled="
                          Invoices.transaction_type == 'return' ||
                            returnItemEnable ||
                            state.system.isOffline ||
                            $loading
                        "
                        >Return Items</b-dropdown-item
                      >
                      <b-dropdown-item
                        variant="dark"
                        class="fs-13"
                        v-if="
                          !transTypeDeposit &&
                            !transTypeCredit &&
                            !transTypeRefundNote
                        "
                        @click="showPopup"
                        >Reprint Invoice</b-dropdown-item
                      >
                      <b-dropdown-divider />
                      <b-dropdown-item
                        variant="dark"
                        class="fs-13"
                        @click="$refs.cloneComponent.initialize()"
                        >Clone to cart
                        <clone-invoice-items-to-cart
                          ref="cloneComponent"
                          :invoiceData="Invoices.data"
                        />
                      </b-dropdown-item>
                      <!-- <b-dropdown-item variant="dark" class="fs-13"
                        >Void Invoice</b-dropdown-item
                      > -->
                    </b-dropdown>
                    <b-dropdown
                      size="sm"
                      v-show="
                        orderPos &&
                          Invoices.order_status != 'Cancelled' &&
                          Invoices.order_status != 'Invoice'
                      "
                      text="Order Options"
                      variant="outline-primary"
                      offset="-140"
                    >
                      <b-dropdown-item
                        variant="dark"
                        class="fs-13"
                        v-show="Invoices.order_status != 'Invoice'"
                        @click="confirmOrder(confirmBtnText)"
                        >{{ confirmBtnText }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        variant="dark"
                        v-show="false"
                        class="fs-13"
                        @click="markAsFulFilled"
                        >Mark as Fulfilled</b-dropdown-item
                      >
                      <!-- <b-dropdown-item
                        variant="dark"
                        :disabled="true || Invoices.order_status == 'Pending'"
                        >Revert to previous Status</b-dropdown-item
                      > -->
                      <b-dropdown-item class="fs-13" disabled variant="dark"
                        >Send Order Status Notification</b-dropdown-item
                      >
                      <b-dropdown-item
                        variant="dark"
                        class="fs-13"
                        @click="takePayment('o')"
                        v-show="Invoices.order_status != 'Invoice'"
                        :disabled="
                          Invoices.order_status == 'Cancelled' ||
                            parseInt(Invoices.amount_due) == 0
                        "
                        >Collect Payment</b-dropdown-item
                      >
                      <b-dropdown-divider />
                      <b-dropdown-item
                        class="fs-13"
                        v-show="Invoices.order_status == 'Invoice'"
                        @click="confirmOrder('Print Invoice')"
                        variant="dark"
                        >Print Invoice</b-dropdown-item
                      >
                      <b-dropdown-item
                        class="fs-13"
                        v-show="Invoices.order_status == 'Invoice'"
                        @click="openShareModal = true"
                        :disabled="
                          !shareInvoiceVia.sms && !shareInvoiceVia.email
                        "
                        variant="dark"
                        >Share Invoice</b-dropdown-item
                      >
                      <b-dropdown-item
                        class="fs-13"
                        variant="dark"
                        @click="rePrint"
                        v-show="
                          ['Pending', 'Confirmed', 'Packed'].includes(
                            Invoices.order_status
                          )
                        "
                        >Print Order Receipt</b-dropdown-item
                      >
                      <b-dropdown-item class="fs-13" disabled variant="dark"
                        >Share Order Receipt</b-dropdown-item
                      >
                      <b-dropdown-divider />
                      <b-dropdown-item class="fs-13" variant="dark" disabled
                        >Edit Order</b-dropdown-item
                      >
                      <b-dropdown-item
                        class="fs-13"
                        variant="dark"
                        @click="
                          $refs['cancel-modal'].show(), (cancelOrderRemark = '')
                        "
                        :disabled="
                          Invoices.order_status == 'Cancelled' ||
                            Invoices.order_status == 'Invoice'
                        "
                        >Cancel Order</b-dropdown-item
                      >
                    </b-dropdown>
                    <router-link
                      v-bind:to="'../order-management'"
                      v-show="
                        (orderPos && Invoices.order_status == 'Invoice') ||
                          (orderPos && Invoices.order_status == 'Cancelled')
                      "
                    >
                      <b-button
                        size="sm"
                        id="back-to-invoices"
                        variant="primary"
                        :disabled="$loading"
                        >Back to Orders</b-button
                      >
                    </router-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section class="mt-1 checkout">
        <b-container fluid>
          <b-row>
            <b-col lg="4" md="4">
              <div class="table-dark-bg box-shadow p-3 pb-0 invoice-dtl">
                <div
                  :class="{
                    'responsive-height':
                      orderPos && !Invoices.order_status == 'Cancelled',
                    'responsive-height-no-btn':
                      orderPos && Invoices.order_status == 'Cancelled',
                  }"
                  style="height:calc(100vh - 153px)"
                >
                  <div v-if="!orderPos">
                    <h6
                      class="fw-normal"
                      v-if="
                        !transTypeDeposit &&
                          !transTypeCredit &&
                          !transTypeRefundNote
                      "
                    >
                      Invoice Details
                    </h6>
                    <hr
                      class="my-2"
                      v-if="
                        !transTypeDeposit &&
                          !transTypeCredit &&
                          !transTypeRefundNote
                      "
                    />
                    <div>
                      <b-row>
                        <b-col md="6">
                          <label
                            for
                            v-if="transTypeRefundNote || transTypeCredit"
                            >Transaction ID</label
                          >
                          <label for v-else>Invoice Number</label>
                          <p
                            v-text="
                              transTypeDeposit ||
                              transTypeCredit ||
                              transTypeRefundNote
                                ? depositData.transaction_summary.transaction_id
                                : Invoices.order_id
                            "
                          />
                        </b-col>
                        <b-col
                          md="6"
                          v-if="!transTypeRefundNote && !transTypeCredit"
                        >
                          <label>Issued Store Name</label>
                          <p v-text="Invoices.store_name" />
                        </b-col>
                        <b-col md="6">
                          <label for>Date / Time</label>
                          <p>
                            {{
                              transTypeDeposit ||
                              transTypeCredit ||
                              transTypeRefundNote
                                ? depositData.transaction_summary.date
                                : $moment(new Date(InvoiceDateTime)).format(
                                    " Do MMM YYYY h:mm A"
                                  )
                            }}
                          </p>
                        </b-col>
                        <b-col
                          md="6"
                          v-if="
                            transTypeDeposit ||
                              transTypeCredit ||
                              transTypeRefundNote
                          "
                        >
                          <label>Cashier</label>
                          <p
                            v-text="
                              depositData.transaction_summary.cashier ==
                              undefined
                                ? '-'
                                : depositData.transaction_summary.cashier
                            "
                          />
                        </b-col>

                        <b-col md="12">
                          <!-- <label>Bill Remarks</label>
                          <p>{{Invoices.message}}</p>-->
                        </b-col>
                      </b-row>

                      <!-- <h6 class="mt-3 fw-normal">Payment Summary</h6>
                    <hr />
                    <b-row class="mt-3">
                      <b-col md="6">
                        <label>Total Amount</label>
                        <p>₹ {{Invoices.total}}</p>
                      </b-col>
                      <b-col md="6">
                        <label>Total Paid</label>
                        <p>₹ {{Invoices.total}} {{Invoices.payment_method}}</p>
                      </b-col>
                      </b-row>-->
                    </div>
                    <h6 class="fw-normal pb-1">Customer Information</h6>
                    <hr class="my-2" />
                    <b-row class="mb-4">
                      <b-col md="6">
                        <label>Customer Phone Number</label>
                        <p
                          v-text="
                            transTypeDeposit ||
                            transTypeCredit ||
                            transTypeRefundNote
                              ? depositData.customer.mobile
                              : Invoices.mobile
                          "
                        />
                      </b-col>
                      <b-col md="6">
                        <label>Customer Name</label>
                        <p
                          class="text-muted"
                          v-if="
                            depositData.customer.customer_name == ' ' ||
                              Invoices.customer_name == ' '
                          "
                        >
                          Not Specified
                        </p>
                        <p
                          v-else
                          v-text="
                            transTypeDeposit ||
                            transTypeCredit ||
                            transTypeRefundNote
                              ? depositData.customer.customer_name
                              : Invoices.customer_name
                          "
                        />
                      </b-col>
                      <b-col
                        md="12"
                        v-if="
                          transTypeDeposit ||
                            transTypeCredit ||
                            transTypeRefundNote
                        "
                      >
                        <label>Customer Group</label>
                        <p v-text="depositData.customer.group" />
                      </b-col>
                      <b-col md="6" v-if="transTypeDeposit">
                        <label>Previous Account Balance</label>
                        <p
                          v-text="
                            currencySymbol +
                              parseFloat(
                                depositData.transaction_summary
                                  .previous_act_balance
                              ).toFixed(2)
                          "
                        />
                      </b-col>
                      <b-col md="6" v-if="transTypeDeposit">
                        <label>Updated Account Balance</label>
                        <p
                          v-text="
                            currencySymbol +
                              parseFloat(
                                depositData.transaction_summary
                                  .update_act_balance
                              ).toFixed(2)
                          "
                        />
                      </b-col>
                    </b-row>
                    <!-- </div> -->
                  </div>
                  <div v-else>
                    <b-row class="mb-1">
                      <b-col md="6">
                        <label class="mb-0">Fulfillment Type</label>
                        <p class="mb-2" v-text="Invoices.fulfillment_type" />
                      </b-col>
                      <b-col md="6">
                        <label class="mb-0">Current Order Status</label>
                        <p class="mb-2" v-text="getOrderStatus" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="6">
                        <label class="mb-0">Order Number</label>
                        <p class="mb-2" v-text="Invoices.order_id" />
                      </b-col>
                      <b-col md="6">
                        <label class="mb-0">Date / Time</label>
                        <p class="mb-2">
                          {{
                            $moment(new Date(InvoiceDateTime)).format(
                              "Do MMM YYYY h:mm A"
                            )
                          }}
                        </p>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="6">
                        <label class="mb-0">Due Date</label>
                        <p class="mb-2">
                          {{
                            $moment(new Date(Invoices.due_date)).format(
                              "Do MMM YYYY"
                            )
                          }}
                        </p>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="6">
                        <label class="mb-0">Assigned Salesperson</label>
                        <p class="mb-2">-</p>
                      </b-col>
                      <b-col md="6">
                        <label class="mb-0">Cashier</label>
                        <p class="mb-2" v-text="Invoices.cashier_name" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="6">
                        <label class="mb-0">Source</label>
                        <p class="mb-2" v-text="Invoices.order_source" />
                      </b-col>
                      <b-col md="6">
                        <label class="mb-0">Store</label>
                        <p class="mb-2" v-text="Invoices.store_name" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <label class="mb-0">Bill Remark</label>
                        <p class="mb-2" v-text="Invoices.remark" />
                      </b-col>
                    </b-row>
                    <h6 class="fw-normal mt-4">Customer Information</h6>
                    <hr class="my-3" />
                    <b-row class="mb-1">
                      <b-col md="6">
                        <label class="mb-0">Customer Name</label>
                        <p v-text="Invoices.customer_name" />
                      </b-col>
                      <b-col md="6">
                        <label class="mb-0">Phone Number</label>
                        <p class="mb-2" v-text="Invoices.mobile" />
                      </b-col>
                      <b-col md="12">
                        <label class="mb-0">Customer Group</label>
                        <p
                          class="mb-2"
                          v-text="
                            Invoices.customer_group == ''
                              ? '-'
                              : Invoices.customer_group
                          "
                        />
                      </b-col>
                      <b-col md="12">
                        <label class="mb-0">Address</label>
                        <p class="mb-2" v-text="Invoices.customer_address" />
                      </b-col>
                    </b-row>
                  </div>
                </div>

                <b-row class="mt-3">
                  <b-col lg="12">
                    <div
                      class="action-btns d-flex justify-content-center"
                      v-if="!orderPos"
                    >
                      <b-button
                        v-if="
                          !transTypeDeposit &&
                            !transTypeCredit &&
                            !transTypeRefundNote
                        "
                        variant="danger"
                        block
                        id="return-items"
                        class="mr-1"
                        @click="returnItems"
                        :disabled="
                          Invoices.transaction_type == 'return' ||
                            returnItemEnable ||
                            state.system.isOffline ||
                            $loading
                        "
                        >Return Items</b-button
                      >

                      <b-button
                        v-if="
                          !transTypeDeposit &&
                            !transTypeCredit &&
                            !transTypeRefundNote
                        "
                        @click="showPopup"
                        variant="primary"
                        block
                        class="ml-1"
                        id="reprint-invoice"
                        :disabled="
                          isReprintDisable || returnBtnEnable || $loading
                        "
                        >Reprint Invoice</b-button
                      >
                      <b-button
                        v-if="
                          transTypeDeposit ||
                            transTypeCredit ||
                            transTypeRefundNote
                        "
                        block
                        class="mr-1"
                        @click="getDepositPrint"
                        id="print-invoice"
                        >Print Receipt</b-button
                      >
                      <b-button
                        v-if="
                          transTypeDeposit ||
                            transTypeCredit ||
                            transTypeRefundNote
                        "
                        block
                        class="mr-1"
                        @click="openShareModal = true"
                        id="share-invoice-btn"
                        :disabled="
                          $loading ||
                            (!shareInvoiceVia.sms && !shareInvoiceVia.email)
                        "
                        >Share Receipt</b-button
                      >
                    </div>
                    <div v-else>
                      <b-row>
                        <b-col lg="6" class="pr-1" v-show="confirmBtnDisp">
                          <b-button
                            variant="primary"
                            block
                            :disabled="
                              $loading || Invoices.order_status == 'Cancelled'
                            "
                            @click="confirmOrder(confirmBtnText)"
                            v-text="confirmBtnText"
                            id="confirm-order"
                          />
                          <b-button
                            block
                            disabled
                            id="edit-order"
                            v-show="false"
                            >Edit Order</b-button
                          >
                        </b-col>
                        <b-col
                          lg="12"
                          v-show="
                            !confirmBtnDisp &&
                              Invoices.order_status != 'Cancelled'
                          "
                        >
                          <b-row class="align-items-center">
                            <b-col md="6" class="pr-1">
                              <b-button
                                variant="primary"
                                block
                                :disabled="
                                  $loading ||
                                    Invoices.order_status == 'Cancelled'
                                "
                                @click="confirmOrder('Print Invoice')"
                                v-text="`Print Invoice`"
                                id="confirm-order"
                              />
                            </b-col>
                            <b-col md="6" class="pl-1">
                              <b-button
                                block
                                :disabled="
                                  $loading ||
                                    (!shareInvoiceVia.sms &&
                                      !shareInvoiceVia.email)
                                "
                                @click="openShareModal = true"
                                v-text="`Share Invoice`"
                                id="confirm-order"
                              />
                              <!-- $refs['share-invoice-modal'].show() -->
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col lg="6" class="pl-1" v-show="confirmBtnDisp">
                          <b-button
                            block
                            @click="rePrint"
                            :disabled="
                              $loading ||
                                !['Pending', 'Confirmed', 'Packed'].includes(
                                  Invoices.order_status
                                )
                            "
                            id="print-order-receipt"
                            >Print Order Receipt</b-button
                          >
                        </b-col>
                        <b-col lg="6" class="pl-0">
                          <b-button
                            @click="takePayment('o')"
                            variant="secondary"
                            block
                            :disabled="
                              $loading ||
                                Invoices.order_status == 'Cancelled' ||
                                parseInt(Invoices.amount_due) == 0
                            "
                            id="take-payment"
                            v-show="false"
                            >Take Payment</b-button
                          >
                          <b-button
                            variant="danger"
                            block
                            @click="
                              $refs['cancel-modal'].show(),
                                (cancelOrderRemark = '')
                            "
                            :disabled="
                              $loading || Invoices.order_status != 'Pending'
                            "
                            id="cancel-order"
                            v-show="false"
                            >Cancel Order</b-button
                          >
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col lg="8" md="8" class="pl-0">
              <div class="table-dark-bg box-shadow px-0 pt-3 pb-2 sale">
                <div class="w-100 d-flex justify-content-between px-3 pb-1">
                  <h6
                    class="fw-normal"
                    v-if="transTypeRefundNote || transTypeCredit"
                  >
                    Credit Note<span v-if="transTypeRefundNote">(s)</span>
                  </h6>
                  <h6 class="fw-normal" v-else>Order Summary</h6>
                  <h6 class="fw-normal text-right">
                    {{
                      transTypeDeposit || transTypeCredit || transTypeRefundNote
                        ? formatText(orderItems.length, "0")
                        : parseFloat(
                            formatText(Invoices.cart_qty_total, "0")
                          ).toFixed(2)
                    }}
                    Item(s)
                  </h6>
                </div>
                <div style="height:calc(100vh - 335px)" class="sale-summary">
                  <div>
                    <b-table
                      striped
                      :fields="fields"
                      :items="orderItems"
                      class="table cart-table table-dark px-5"
                      style="line-height: 16px"
                    >
                      <template slot="id" slot-scope="data" class="sticky">
                        {{ data.index + 1 }}
                      </template>
                      <template v-slot:cell(product)="data">
                        <div v-html="data.item.product"></div>
                      </template>
                    </b-table>
                  </div>
                </div>
                <hr class="mx-0" />
                <div class="clearfix"></div>
                <b-row class="mt-2 cart-total px-2 mx-2">
                  <b-col md="6">
                    <div class="sale-inv-c-total pr-1">
                      <b-row v-show="!orderPos">
                        <b-col md="8 light">
                          <p
                            v-text="
                              transTypeDeposit ||
                              transTypeCredit ||
                              transTypeRefundNote
                                ? depositData.save_payment_data
                                    .payment_gateway_type
                                : Invoices.payment_method
                            "
                          />
                        </b-col>
                        <b-col md="4 text-success  text-right"
                          >{{ currencySymbol }}
                          {{
                            Invoices != "" &&
                            parseFloat(Invoices.amount_due) != 0
                              ? parseFloat(
                                  parseFloat(Invoices.total) -
                                    parseFloat(Invoices.amount_due)
                                ).toFixed(2)
                              : transTypeDeposit ||
                                transTypeCredit ||
                                transTypeRefundNote
                              ? formatAmount(orderTotal)
                              : formatAmount(Invoices.total)
                          }}</b-col
                        >
                      </b-row>
                      <b-row v-show="orderPos && Invoices != ''">
                        <b-col md="12 light">
                          <div
                            v-for="(mop, index) in Invoices.payment_method"
                            :key="index"
                            class="d-flex justify-content-between"
                          >
                            <p v-text="mop.display_name" />
                            <p
                              :class="
                                parseFloat(mop.value) < 0
                                  ? 'text-danger'
                                  : 'text-success'
                              "
                              v-text="currencySymbol + formatAmount(mop.value)"
                            />
                          </div>
                        </b-col>
                      </b-row>
                      <!-- <b-row>
                        <b-col md="6" class="light">
                          <p>&nbsp;</p>
                        </b-col>
                        <b-col md="6 text-right">&nbsp;</b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6" class="light">
                          <p>&nbsp;</p>
                        </b-col>
                        <b-col md="6 text-right">&nbsp;</b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6" class="light">
                          <p>&nbsp;</p>
                        </b-col>
                        <b-col md="6 text-right">&nbsp;</b-col>
                      </b-row> -->
                    </div>
                    <b-row class="total p-3 mt-2">
                      <b-col class="light pl-0">
                        <p
                          class="mb-0 mt-1"
                          v-text="
                            (parseFloat(Invoices.amount_due) != 0 &&
                              Invoices.order_status != 'Cancelled') ||
                            Invoices.order_status == 'Cancelled'
                              ? 'Amount Due'
                              : 'Amount Paid'
                          "
                        />
                      </b-col>
                      <b-col class="pr-0">
                        <h5
                          class="fw-normal text-right mb-0"
                          :class="
                            (parseFloat(Invoices.amount_due) != 0 &&
                              Invoices.order_status != 'Cancelled') ||
                            Invoices.order_status == 'Cancelled'
                              ? 'text-danger'
                              : 'text-success'
                          "
                          v-text="
                            Invoices.order_status == 'Cancelled'
                              ? currencySymbol +
                                formatAmount(Invoices.amount_due)
                              : currencySymbol + formatAmount(orderTotal)
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <!-- <b-col md="2"></b-col> -->
                  <b-col md="6" class="pr-0">
                    <div class="sale-inv-c-total px-3">
                      <!-- {{state.billing.cart.bill_summary}} -->
                      <div v-for="(item, index) in billSummary" :key="index">
                        <div
                          class="row"
                          v-if="
                            !transTypeDeposit &&
                              !transTypeCredit &&
                              !transTypeRefundNote
                          "
                        >
                          <div class="col light">
                            <p>{{ item.display_text }}</p>
                          </div>
                          <div class="col text-right">
                            <p>
                              {{ item.sign != "" ? item.sign : "" }}
                              {{ currencySymbol }}
                              {{
                                item.value == ""
                                  ? "0.00"
                                  : formatAmount(item.value)
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <!--   <b-row>
                        <b-col md="6" class="light">
                          <p>Subtotal</p>
                        </b-col>
                        <b-col md="6 text-right">₹ {{Invoices.sub_total}}</b-col>
                      </b-row>
                      <b-row>
                        <b-col class="light" md="6 ">
                          <p>Discount</p>
                        </b-col>
                        <b-col md="6 text-right">- ₹{{Invoices.discount}}</b-col>
                      </b-row>
                      <b-row>
                        <b-col class="light" md="6">
                          <p>Taxes</p>
                        </b-col>
                        <b-col md="6 text-right">₹{{Invoices.tax_total}}</b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6" class="light">
                          <p>Carry Bags</p>
                        </b-col>
                        <b-col md="6 text-right">₹{{Invoices.carry_bag_total}}</b-col>
                      </b-row>-->
                    </div>

                    <div class="mb-1 total p-3 mt-2 w-100">
                      <b-row class="px-3">
                        <b-col class="light pl-0">
                          <p class="mb-0 mt-1">Total</p>
                        </b-col>
                        <b-col class="pr-0">
                          <h5 class="fw-normal text-right mb-0">
                            {{ currencySymbol }}
                            {{
                              transTypeDeposit ||
                              transTypeCredit ||
                              transTypeRefundNote
                                ? formatAmount(
                                    depositData.save_payment_data.total
                                  )
                                : formatAmount(Invoices.total)
                            }}
                          </h5>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </section>

      <!-- Invoice Print -->

      <b-modal
        ref="print-invoice-modal"
        hide-header
        hide-footer
        centered
        @hidden="hidePrintModal"
        :size="printSize == 'A4' ? 'xl' : ''"
      >
        <div class="modal-head" style="border-bottom: 1px #c0c0c0 solid">
          <b-row class="pb-3 print_box">
            <b-col>
              <h3
                class="modal-title"
                v-text="
                  orderPos &&
                  ['Pending', 'Confirmed', 'Packed'].includes(
                    Invoices.order_status
                  )
                    ? 'Order Reciept'
                    : 'Invoice'
                "
              />
            </b-col>
            <b-col>
              <b-button
                class="float-right grey-btn"
                @click="printInvoice"
                id="print"
                >Print</b-button
              >
              <b-button
                style="margin-right: 10px"
                class="float-right grey-outline-btn"
                @click="hidePrintModal"
                id="close"
                >Close</b-button
              >
            </b-col>
          </b-row>
        </div>
        <div id="cool">
          <print-box :data="html" :print_type="'re_print'" />
        </div>
        <!-- <template slot="modal-footer" center>
          <b-button variant="success" size="lg" @click="printInvoice">Print</b-button>
            <b-button variant="danger" @click="hidePrintModal">Cancel</b-button>
        </template>-->
      </b-modal>

      <!-- Re-Modal -->

      <b-modal
        ref="re-print"
        id="re-print"
        size="sm"
        hide-footer
        title="Authorization required"
        centered
      >
        <b-form v-on:submit.prevent="reprintVerification">
          <b-form-group
            id="reprint-verification"
            label="Ask the manager for the 6-digit passcode"
            label-for="Cust-Phone"
          >
            <input
              type="password"
              min="0"
              placeholder="Enter Authorization Password"
              autocomplete="off"
              maxlength="6"
              autofocus
              id="auth-password"
              class="mb-4 form-control"
              v-model="authorizationPassword"
              on-click="show"
            />
          </b-form-group>
          <b-row>
            <b-col md="7">
              <p v-if="isFeedback" class="error">
                <img src="../assets/images/alert.svg" alt />&nbsp; Incorrect
                code.
              </p>
            </b-col>
            <b-col md="5">
              <b-button
                type="submit"
                variant="primary"
                class="float-right"
                :disabled="btnEnableReprint || $loading"
                id="continue"
              >
                <span v-if="!$loading">Continue</span>
                <b-spinner small v-if="$loading" />
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>

      <!-- Return Password -->

      <b-modal
        ref="return-item"
        id="return-item"
        size="sm"
        hide-footer
        title="Authorization required"
        centered
      >
        <form v-on:submit.prevent="returnItemVerification">
          <b-form-group
            id="return-verification"
            label="Ask the manager for the 6-digit passcode"
            label-for="Cust-Phone"
          >
            <b-form-input
              type="password"
              min="0"
              id="returntAuthorization"
              aria-describedby="code-error"
              placeholder="Enter Authorization Password"
              autofocus
              autocomplete="off"
              class="mb-4"
              maxlength="6"
              v-model="returntAuthorization"
              :disabled="$loading"
            ></b-form-input>
            <b-row>
              <b-col md="7">
                <p v-if="isFeedback" class="error">
                  <img src="../assets/images/alert.svg" alt />&nbsp; Incorrect
                  code.
                </p>
              </b-col>
              <b-col md="5">
                <b-button
                  type="submit"
                  variant="primary"
                  class="float-right"
                  :disabled="btnEnableReturnPassword || $loading"
                  id="continue"
                >
                  <span v-if="!$loading">Continue</span>
                  <b-spinner small v-if="$loading" />
                </b-button>
              </b-col>
            </b-row>
          </b-form-group>
        </form>
      </b-modal>

      <b-modal
        ref="cancel-modal"
        id="cancel-modal"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
        centered
        title="Cancel Order"
      >
        <div
          v-if="
            omsSettings.refund_mode.cash && omsSettings.refund_mode.credit_note
          "
        >
          <!-- <h6 class="mb-3">Do you want to cancel this order?</h6> -->
          <p
            v-text="
              `To cancel this order, please confirm the mode to refund ${currencySymbol}${formatAmount(
                Invoices.total_paid
              )} paid
          by the customer.`
            "
          />
          <b-form-group class="mt-2">
            <small for="refund-type">Select Mode of Refund</small>
            <b-form-radio-group
              id="invoice_type"
              v-model="orderRefund.type"
              :options="orderRefund.options"
              name="radio-options"
              class="mt-2 mb-2"
              style="padding-bottom: 8px;"
            />
          </b-form-group>
        </div>
        <div v-else>
          <p
            v-text="
              `This order will be cancelled and the amount of ${currencySymbol}${formatAmount(
                Invoices.total_paid
              )} will be refunded to the customer by: ${
                omsSettings.refund_mode.cash ? 'Cash' : 'Store Credit'
              }`
            "
          />
        </div>
        <b-form-textarea
          id="cancelOrderRemark"
          type="text"
          size="sm"
          autocomplete="off"
          :disabled="$loading"
          placeholder="Enter Remark"
          no-resize
          v-model="cancelOrderRemark"
        />
        <b-row class="mt-3">
          <b-col md="6" class="pr-1">
            <b-button
              block
              @click="$refs['cancel-modal'].hide()"
              :disabled="$loading"
              variant="outline-primary"
            >
              Close
            </b-button>
          </b-col>
          <b-col md="6" class="pl-1">
            <b-button
              @click="cancelOrder"
              variant="primary"
              class="w-100"
              block
              :disabled="cancelOrderRemark.length < 3 || $loading"
            >
              <span v-if="!$loading">Confirm</span>
              <b-spinner small v-if="$loading" />
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <!-- Payment Modal -->
      <b-modal
        ref="payment-model"
        size="sm"
        hide-footer
        centered
        no-close-on-backdrop
        no-close-on-esc
        :title="'Collect Pending Payment'"
      >
        <p
          class="pt-2"
          v-text="
            'Invoice can only be generated after the customer has made the full payment for this order.'
          "
        />
        <p class="pt-2" v-text="'Do you wish to collect payment now?'" />
        <div class="d-flex pt-3">
          <b-button
            class="mr-1"
            block
            @click="$refs['payment-model'].hide()"
            :disabled="$loading"
            variant="outline-primary"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            block
            class="ml-1"
            :disabled="$loading"
            @click="takePayment('i')"
          >
            <span v-if="!$loading">Continue</span>
            <b-spinner small v-if="$loading" />
          </b-button>
        </div>
      </b-modal>

      <b-modal
        centered
        no-close-on-esc
        no-close-on-backdrop
        size="sm"
        hide-footer
        title="Confirm Order"
        ref="order-inventory-modal"
        id="order-inventory-modal"
      >
        <p>
          Sufficient inventory is available for all products in this order. Do
          you wish to confirm this order automatically?
        </p>
        <p>
          You can also tap 'Review' if you wish to review all products before
          confirmation.
        </p>
        <b-row class="mt-4">
          <b-col md="6" class="pr-1">
            <b-button
              block
              variant="outline-primary"
              :disabled="$loading"
              @click="reviewConfirmOrder"
              >Review</b-button
            >
          </b-col>
          <b-col md="6" class="pl-1">
            <b-button
              block
              variant="primary"
              :disabled="$loading"
              @click="confirmOrderReview"
            >
              <span v-if="!$loading">Confirm</span>
              <b-spinner small v-else />
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        centered
        hide-footer
        ref="generate-inv-unavail"
        id="generate-inv-unavail"
        title="Unavailable Products"
        size="sm"
      >
        <div
          style="max-height: 320px;"
          class="overflow-auto item-list mt-1 mb-1 custom-scroll"
        >
          <div>
            <ul class="list-unstyled unavailable-prod-list">
              <li
                v-for="(prod, key) in unavailableProducts"
                :key="key"
                class="px-2 py-2"
              >
                <div>
                  <p class="m-0">
                    <span v-text="prod.name" />
                    <span class="mr-2 float-right" v-text="prod.barcode" />
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </b-modal>
      <share-invoice-modal
        :open="openShareModal"
        :custMob="getPhoneNumber"
        :custEmail="''"
        :invoiceNo="getInvoiceId"
        @close-modal-share="openShareModal = false"
      />
      <message-box
        :open="error"
        @close-message="flushError"
        :message="errorMsg"
      />
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import PrintBox from "../components/PrintBox";
import qz from "../printer";
import MessageBox from "../components/MessageBox";
import * as msg from "../message";
import ShareInvoiceModal from "../components/ShareInvoiceModal";
import CloneInvoiceItemsToCart from "../components/CloneInvoiceItemsToCart";

library.add(faInfoCircle);

export default {
  name: "order-completed",
  props: ["order_id", "order_from"],
  mixins: [validationMixin],
  components: {
    Dashboard,
    PrintBox,
    Loading,
    MessageBox,
    ShareInvoiceModal,
    CloneInvoiceItemsToCart,
  },
  mounted() {
    this.$store.commit("billing/setInvoiceDetails", {
      invoice_no: this.order_id,
      amount: this.orderTotal,
    });
    if (
      !this.transTypeDeposit ||
      !this.transTypeCredit ||
      !this.transTypeRefundNote
    )
      this.fetchOrderItems();

    this.$store.commit("stock/setOrderProducts", []);
    // else {
    // }
    // this.rePrintEnable();
    // this.returnEnable();
    if (this.order_from == "success") {
      setTimeout(() => {
        window.location.replace(`#/order-summary/${this.order_id}`);
      }, 2000);
    }
    if (
      !this.checkEmpty(this.omsSettings) &&
      !this.checkEmpty(this.omsSettings.refund_mode)
    )
      this.orderRefund.type = this.omsSettings.refund_mode.cash
        ? "cash"
        : "credit";
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    billSummary() {
      let data = [];
      if (this.Invoices != "") {
        this.Invoices.bill_summary.filter((item) => {
          if (
            [
              "tax_total",
              "sub_total",
              "manual_discount",
              "bill_buster_discount",
              "roundoff",
            ].includes(item.name)
          ) {
            data.push({
              display_text: item.display_text,
              value: item.value,
              sign: item.sign,
            });
          } else if (item.name == "discount") {
            data.push({
              display_text: item.display_text,
              value: item.value,
              sign: "-",
            });
          } else {
            return false;
          }
        });
        return data;
      } else return false;
    },
    orderItems() {
      let data = [];
      if (
        this.Invoices != "" &&
        !this.transTypeDeposit &&
        !this.transTypeCredit &&
        !this.transTypeRefundNote
      ) {
        this.Invoices.data.map((item, index) => {
          data.push({
            id: index + 1,
            product:
              "<div>" +
              item.product_data.p_name +
              " <br /> <span style='color: #808080'>" +
              item.product_data.barcode +
              "</span></div>",
            // barcode: barcode,
            qty: item.qty,
            unit_price:
              this.currencySymbol +
              this.formatAmount(item.product_data.unit_mrp),
            discount: this.currencySymbol + this.formatAmount(item.discount),
            sale_price:
              this.currencySymbol +
              this.formatAmount(item.product_data.r_price),
            net_price: this.currencySymbol + this.formatAmount(item.amount),
            tax: this.currencySymbol + this.formatAmount(item.tax_amount),
            // tax_total: item.tax_total
          });
          //  console.log(Invoices.data.item.Invoices);
        });
      } else if (this.transTypeDeposit) {
        this.state.billing.billing.pay_balance_deposit.transaction_summary.data.map(
          (item, index) => {
            data.push({
              id: index + 1,
              product: "<div>" + item.doc_no + "</div>",
              value: this.currencySymbol + this.formatAmount(item.value),
              paid_off_previously:
                this.currencySymbol + this.formatAmount(item.prev_paid),
              balance: this.currencySymbol + this.formatAmount(item.balance),
              payable_amount:
                this.currencySymbol + this.formatAmount(item.balance),
            });
          }
        );
      } else if (this.transTypeCredit) {
        this.state.billing.billing.pay_balance_deposit.transaction_summary.data.map(
          (item, index) => {
            data.push({
              id: index + 1,
              product: "<div>" + item.doc_no + "</div>",
              remark: item.remark != "" ? item.remark : "-",
              valid_till: this.$moment(item.valid_till).format("Do MMM YYYY"),
              payable_amount:
                this.currencySymbol + this.formatAmount(item.prev_paid),
            });
          }
        );
      } else if (this.transTypeRefundNote) {
        this.state.billing.billing.pay_balance_deposit.transaction_summary.data.map(
          (item, index) => {
            data.push({
              id: index + 1,
              product: "<div>" + item.doc_no + "</div>",
              value: this.currencySymbol + this.formatAmount(item.value),
              redeemed: this.currencySymbol + this.formatAmount(item.redeemed),
              refund_amount:
                this.currencySymbol + this.formatAmount(item.refund_amount),
            });
          }
        );
      }

      return data;
    },
    isReprintDisable() {
      let check = true;
      this.state.system.settings.print.map((item) => {
        if (item.name == "bill_reprint") {
          if (item.status == 1) {
            check = false;
          }
        }
      });
      return check;
    },
    btnEnableReprint() {
      let check = true;
      this.isFeedback = false;
      if (this.authorizationPassword.length == 6) {
        check = false;
      }
      return check;
    },
    returnItemEnable() {
      let check = true;
      let returnData = this.state.system.settings.vendor_app_menu
        .profile_tab_menu[0].data;
      var i = 0;
      for (i = 0; returnData.length > i; i++) {
        if (returnData[i].name == "exchange_return") {
          if (returnData[i].status == 1) {
            check = false;
          } else {
            check = true;
          }
        }
      }
      return check;
    },
    btnEnableReturnPassword() {
      let check = true;
      this.isFeedback = false;
      if (this.returntAuthorization.length == 6) {
        check = false;
      }
      return check;
    },
    printSize() {
      let size = 80;
      this.state.system.settings.print.map((item) => {
        if (item.name == "bill_reprint") {
          size = item.width;
        }
      });
      return size;
    },
    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        check = true;
      }
      return check;
    },
    orderPos() {
      let check = false;
      if (
        this.Invoices.transaction_sub_type != "" &&
        this.Invoices.transaction_sub_type == "order"
      ) {
        if (
          !this.transTypeDeposit &&
          !this.transTypeCredit &&
          !this.transTypeRefundNote
        )
          check = true;
      }
      return check;
    },
    transTypeDeposit() {
      let check = false;
      if (
        this.state.billing.billing.pay_balance_deposit.trans_sub_type ==
        "Deposit-DN"
      )
        check = true;
      return check;
    },
    transTypeCredit() {
      let check = false;
      if (
        this.state.billing.billing.pay_balance_deposit.trans_sub_type ==
        "Credit-Note"
      )
        check = true;
      return check;
    },
    transTypeRefundNote() {
      let check = false;
      if (
        this.state.billing.billing.pay_balance_deposit.trans_sub_type ==
        "Refund-CN"
      )
        check = true;
      return check;
    },
    fields() {
      let field = [];
      if (this.transTypeDeposit)
        field = [
          {
            key: "id",
            label: "#",
            class: "text-left w-2 pl-3",
          },
          {
            key: "product",
            label: "Debit Note Number",
            class: "text-left w-20",
          },
          {
            key: "value",
            label: "Value",
            class: "text-center w-10",
          },
          {
            key: "paid_off_previously",
            label: "Paid off previosuly",
            class: "text-center w-10",
          },

          {
            key: "balance",
            label: "Balance",
            class: "text-center w-10",
          },
          {
            key: "payable_amount",
            label: "Payable Amount",
            class: "text-center w-10",
          },
        ];
      else if (this.transTypeCredit)
        field = [
          {
            key: "id",
            label: "#",
            class: "text-left w-2 pl-3",
          },
          {
            key: "product",
            label: "Credit Note Number",
            class: "text-left w-20",
          },
          {
            key: "remark",
            label: "Remark",
            class: "text-center w-30",
          },
          {
            key: "valid_till",
            label: "Valid Till",
            class: "text-center w-10",
          },
          {
            key: "payable_amount",
            label: "Payable Amount",
            class: "text-center w-10",
          },
        ];
      else if (this.transTypeRefundNote)
        field = [
          {
            key: "id",
            label: "#",
            class: "text-left w-2 pl-3",
          },
          {
            key: "product",
            label: "Debit Note Number",
            class: "text-left w-30",
          },
          {
            key: "value",
            label: "Value",
            class: "text-center w-20",
          },
          {
            key: "redeemed",
            label: "Redeemed",
            class: "text-center w-20",
          },
          {
            key: "refund_amount",
            label: "Refund Amount",
            class: "text-center w-20",
          },
        ];
      else
        field = [
          {
            key: "id",
            label: "#",
            class: "text-left w-2 pl-3",
          },
          {
            key: "product",
            label: "Product Name(s)",
            class: "text-left w-30",
          },
          {
            key: "qty",
            label: "Qty.",
            class: "text-center w-10",
          },
          {
            key: "unit_price",
            label: "Unit Price",
            class: "text-center w-10",
          },

          {
            key: "sale_price",
            label: "Sale Price",
            class: "text-center w-10",
          },
          {
            key: "discount",
            label: "Discount",
            class: "text-center w-10",
          },
          {
            key: "tax",
            label: "Tax",
            class: "text-center w-10",
          },
          {
            key: "net_price",
            label: "Net Price",
            class: "text-right w-10 pr-3",
          },
        ];

      return field;
    },
    depositData() {
      return this.state.billing.billing.pay_balance_deposit;
    },
    orderTotal() {
      let temp = 0;
      if (
        this.transTypeDeposit ||
        this.transTypeCredit ||
        this.transTypeRefundNote
      )
        temp = this.depositData.save_payment_data.total;
      else
        temp =
          parseFloat(this.Invoices.amount_due) != 0
            ? this.Invoices.amount_due
            : this.Invoices.total;
      return temp;
    },
    billLogo() {
      return this.$store.getters["system/billLogo"];
    },
    qrCode() {
      return this.$store.getters["system/qrCode"];
    },
    confirmBtnText() {
      let btnText = "Confirm Order";
      if (this.Invoices.order_status == "Confirmed") btnText = "Pack Order";
      if (this.Invoices.order_status == "Packed") btnText = "Generate Invoice";
      if (this.Invoices.order_status == "Invoice") btnText = "Print Invoice";
      return btnText;
    },
    confirmBtnDisp() {
      let temp = false;
      if (
        this.Invoices.order_status == "Confirmed" ||
        this.Invoices.order_status == "Packed" ||
        this.Invoices.order_status == "Pending"
      )
        temp = true;
      return temp;
    },
    getOrderStatus() {
      let status = this.Invoices.order_status;

      let temp = "Pending Confirmation";
      if (status == "Confirmed") temp = "Confirmed";
      else if (status == "Packed") temp = "Packed";
      else if (status == "Invoice") temp = "Invoice Generated";
      else if (status == "Order Fulfilled") temp = "Order Fulfilled";
      else if (status == "Cancelled") temp = "Cancelled";

      return temp;
    },
    shareInvoiceVia() {
      let temp = { email: false, sms: false };
      temp.email =
        this.state.system.settings.share_invoice_via.allow_via_email.status == 1
          ? true
          : false;
      temp.sms =
        this.state.system.settings.share_invoice_via.allow_via_sms.status == 1
          ? true
          : false;
      return temp;
    },
    getPhoneNumber() {
      let temp = this.Invoices.mobile;
      if (
        this.transTypeRefundNote ||
        this.transTypeDeposit ||
        this.transTypeCredit
      )
        temp = this.depositData.customer.mobile;
      return temp;
    },
    getInvoiceId() {
      let temp = this.Invoices.invoice_id;
      if (
        this.transTypeRefundNote ||
        this.transTypeDeposit ||
        this.transTypeCredit
      )
        temp = this.depositData.transaction_summary.transaction_id;
      return temp;
    },
    omsSettings() {
      return this.$store.getters["omsSettings"];
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.transTypeDeposit ||
      this.transTypeCredit ||
      this.transTypeRefundNote
    )
      this.$store.commit("billing/clearPayBalDeposit");
    else if (
      this.state.billing.trans_sub_type == "order" &&
      !["/checkout", `/order-confirmation/${this.Invoices.order_id}`].includes(
        to.path
      )
    )
      this.$store.commit("billing/setTransactionSubType", "");

    next();
  },
  beforeDestroy() {
    this.$store.commit("billing/clearInvoiceDetails");
  },
  data() {
    return {
      selected: null,
      html: "",
      style: "",
      loading: true,
      isContentShow: false,
      isFeedback: false,
      isReturn: true,
      returntAuthorization: "",
      authorizationPassword: "",
      returnlist: [],
      Invoices: "",
      InvoiceDateTime: "",
      returnBtnEnable: false,
      loadinOn: false,
      stringHtml: "",
      onApiRequest: false,
      cancelOrderRemark: "",
      error: false,
      errorMsg: {
        btnText: "",
        text: "",
        type: "",
      },
      openShareModal: false,
      orderRefund: {
        options: [
          { text: "Cash", value: "cash" },
          { text: "Store Credit", value: "credit" },
        ],
        type: "cash",
      },
      unavailableProducts: [],
    };
  },
  validations: {
    form: {
      returntAuthorization: {
        required,
        maxLength: maxLength(6),
        minLength: minLength(6),
      },
    },
  },
  methods: {
    contentShow(content) {
      this.isContentShow = content;
    },
    hidePrintModal() {
      this.$loading = false;
      this.$refs["print-invoice-modal"].hide();
      this.$loading = false;
    },
    printInvoice() {
      let prtContent = document.getElementById("cool");
      let WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write("<html><head><title>Print Bill</title>");
      if (this.printSize == "A4") {
        WinPrint.document.write(this.html.style);
      } else {
        WinPrint.document.write(
          "<style>table{text-align:center}img{width: 150px; height: auto;}</style>"
        );
      }
      WinPrint.document.write("</head><body>");
      WinPrint.document.write("<div>");
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.write("</div>");
      WinPrint.document.write("</body></html>");
      // WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
    fetchOrderItems: function() {
      if (
        this.transTypeDeposit ||
        this.transTypeCredit ||
        this.transTypeRefundNote
      )
        return;
      this.$loading = true;
      let data = {
        c_id: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        order_id: this.order_id,
        trans_from: this.state.system.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        url: "/order-details",
      };
      if (
        this.state.billing.trans_sub_type == "order" ||
        this.order_from == "success"
      )
        data.billing_mode = this.state.billing.trans_sub_type;
      axios.post(data.url, data).then((response) => {
        this.Invoices = response.data;
        this.InvoiceDateTime = response.data.date + " " + response.data.time;
        this.$loading = false;
        this.$store.commit("billing/setInvoiceDetails", {
          invoice_no: this.order_id,
          amount: this.currencySymbol + this.orderTotal,
        });
      });
    },
    reprintVerification: function() {
      this.$loading = true;
      let data = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        operation: "BILL_REPRINT",
        security_code: this.authorizationPassword,
        trans_from: this.state.system.trans_from,
        url: "/vendor/operation-verification",
        terminal_id: this.state.system.settings.terminal_id,
      };
      axios.post(data.url, data).then((res) => {
        if (res.data.status == "success") {
          this.$bvModal.hide("re-print");
          this.$loading = false;
          this.rePrint(res.data.data.security_code_id);
          this.authorizationPassword = "";
        } else {
          this.isFeedback = true;
          this.$loading = false;
        }
      });
    },
    returnItemVerification: function() {
      this.$loading = true;
      let data = {
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        security_code: this.returntAuthorization,
        trans_from: this.state.system.trans_from,
        url: "/return/authorized",
        terminal_id: this.state.system.settings.terminal_id,
        // udidtoken: this.state.trans_from
      };
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "success") {
            this.returnItems();
            this.$bvModal.hide("return-item");
            // this.$loading = false;
          } else {
            this.isFeedback = true;
            this.$loading = false;
          }
        })
        .catch(() => {
          this.$loading = false;
          // this.$v.form.returntAuthorization.$error == true;
        });
    },
    rePrint(security_code_id = "") {
      let self = this;
      let manuName = "";
      if (this.state.system.printer != "") {
        manuName = this.state.system.printer;
      }
      if (typeof Android !== "undefined" && Android !== null) {
        let invoiceData = {
          operation: "BILL_REPRINT",
          cust_mobile_no: this.Invoices.mobile,
          order_id: this.order_id,
          security_code_vu_id: security_code_id,
          // manufacturer_name: this.state.device_name,
          url: "get-duplicate-receipt",
          v_id: this.state.sessions.user.vendor_id,
          api_token: this.state.sessions.user.api_token,
          store_id: this.state.sessions.user.store_id,
          vu_id: this.state.sessions.user.vu_id,
          trans_from: this.state.system.trans_from,
        };
        if (this.orderPos && this.Invoices.invoice_id != "") {
          invoiceData.order_id = this.Invoices.invoice_id;
        }
        // let data = Object.assign(invoiceData, this.customerData);
        axios.post(invoiceData.url, invoiceData).then((res) => {
          // console.log(res.data.print_data);
          let postData = { type: "print_invoice", data: res.data.print_data };

          // printAcknowledgement();
          returnValue(postData);
          self.returnBtnEnable = true;
        });
        // console.log(data);
      } else {
        this.$loading = true;
        let data = Object.assign(
          {
            response_type: "WEB_VIEW",
            cust_mobile_no: this.Invoices.mobile,
            order_id: this.order_id,
            operation: "BILL_REPRINT",
            security_code_vu_id: security_code_id,
            manufacturer_name: manuName,
            url: "/get-duplicate-receipt",
          },
          this.essentialsData
        );

        if (this.orderPos && this.Invoices.invoice_id != "") {
          data.order_id = this.Invoices.invoice_id;
        }

        if (
          this.orderPos &&
          ["Pending", "Confirmed", "Packed"].includes(
            this.Invoices.order_status
          )
        ) {
          data.order_id = this.Invoices.order_id;
          data.trans_type = "order";
        }

        axios
          .post(data.url, data)
          .then((res) => {
            this.$bvModal.hide("re-print");
            //console.log(res.data.print_data);
            if (this.state.system.printer != "" && qz.websocket.isActive()) {
              if (
                this.state.system.isOffline == true &&
                this.state.system.settings.vendor_app_menu.hasOwnProperty(
                  "offline"
                ) &&
                this.state.system.settings.vendor_app_menu.offline.status == 1
              ) {
                this.stringHtml = res.data.print_data;
                this.stringHtml =
                  "<div class='webpos-print'>" + this.stringHtml + "</div>";
              } else {
                if (this.printSize != "A4") {
                  this.stringHtml = res.data.print_data
                    .replace(
                      /<size=24>|<bold>|<\/bold>|<\/size>|<normal>|<\/normal>/gi,
                      ""
                    )
                    .replace(/<center>/gi, "<div class='cool-center'>")
                    .replace(/<left>/gi, "<div class='cool-left'>")
                    .replace(/<right>/gi, "<div class='cool-right'>")
                    .replace(/<text>/gi, "<span>")
                    .replace(/<\/text>/gi, "</span>")
                    .replace(/<\/center>|<\/left>|<\/right>/gi, "</div>");
                  this.stringHtml =
                    "<div class='webpos-print'>" + this.stringHtml + "</div>";
                } else {
                  this.stringHtml = res.data.print_data.html;
                  this.style = res.data.print_data.style;
                  this.stringHtml =
                    "<div class='webpos-print'><div>" +
                    this.stringHtml +
                    "</div></div>";
                }
              }
              setTimeout(() => {
                this.printHtml();
              }, 1000);

              this.$loading = false;
              self.returnBtnEnable = true;
            } else {
              if (this.printSize == "A4") {
                this.html = res.data.print_data;
              } else {
                if (
                  this.state.system.isOffline == true &&
                  this.state.system.settings.vendor_app_menu.hasOwnProperty(
                    "offline"
                  ) &&
                  this.state.system.settings.vendor_app_menu.offline.status == 1
                ) {
                  this.html =
                    this.billLogo.data[0].data != ""
                      ? this.billLogo.img + res.data.print_data
                      : res.data.print_data;
                  this.html = this.qrCode.print
                    ? this.html + this.qrCode.qrImg
                    : this.html;
                } else {
                  this.html =
                    this.billLogo.data[0].data != ""
                      ? this.billLogo.img + res.data.print_data
                      : res.data.print_data;
                  this.html = this.qrCode.print
                    ? this.html + this.qrCode.qrImg
                    : this.html;
                }
              }
              this.$refs["print-invoice-modal"].show();
            }

            // console.log(res.data.status);
            // if (res.data.status == "success") {
            //   this.$loading = false;
            // }
          })
          .catch(() => (this.$loading = false));
      }
    },
    printHtml() {
      // this.$nextTick(() => {
      let billData = [];
      let data = document.querySelectorAll(".webpos-print");
      // console.log(data);

      if (this.state.system.isOffline == true && this.isOfflineEnabled) {
        for (let i = 0; i < data.length; i++) {
          let tempData = data[i].childNodes;
          tempData = tempData[0].childNodes;
          for (let j = 0; j < tempData.length; j++) {
            // for (var k = 0; k < tempData[j].rows.length; k++) {
            // console.log(tempData[j].rows[k].innerText);
            billData.push({
              content: tempData[j].innerText,
              size: tempData[j].innerText.length,
            });
            // }
          }
        }
      } else {
        for (let i = 0; i < data.length; i++) {
          let tempData = data[i].childNodes;
          for (let j = 0; j < tempData.length; j++) {
            billData.push({
              content: tempData[j].textContent,
              size: tempData[j].textContent.length,
            });
          }
        }
      }

      let htmlData = "";
      if (this.state.system.isOffline == true && this.isOfflineEnabled) {
        htmlData = Object.keys(billData)
          .map(function(k) {
            let convert = "";
            if (billData[k].size == 1) {
              convert = billData[k].content;
              convert = convert.toString();
            } else {
              convert = billData[k].content.substr(
                0,
                billData[k].content.length
              );
              convert = convert + "\x0A";
              convert = convert.toString();
            }
            return convert;
          })
          .join("");
      } else {
        htmlData = Object.keys(billData)
          .map(function(k) {
            let convert = "";
            if (billData[k].size == 1) {
              convert = billData[k].content;
              convert = convert.toString();
            } else {
              convert = billData[k].content.substr(
                0,
                billData[k].content.length - 1
              );
              convert = convert + "\x0A";
              convert = convert.toString();
            }
            return convert;
          })
          .join("");
      }
      // console.log(htmlData.toString());

      let config = "";
      let pdata = [];

      let centerAlign = "\x1B" + "\x61" + "\x31";
      let oneLineBreak = this.billLogo.data[0].data != "" ? "\x0A" : "";
      let paperCut = !this.qrCode.print ? "\x1D" + "\x56" + "\x30" : "";
      let lineBreak = !this.qrCode.print ? "\x0A" + "\x0A" + "\x0A" : "\x0A";

      if (this.printSize == "A4") {
        var Pixeldata = [
          {
            type: "pixel",
            format: "html",
            flavor: "plain", // or 'plain' if the data is raw HTML
            data:
              "<html><head>" +
              this.style +
              "</head><body>" +
              this.stringHtml +
              "</body></html>",
          },
        ];
        config = qz.configs.create(this.state.system.printer, {
          units: "mm",
          margins: 6,
        });
        pdata = Pixeldata;
      } else {
        config = qz.configs.create(this.state.system.printer, {
          units: "mm",
        });
        if (this.state.system.printer == "TP 3260" || this.state.system.printer == "RETSOL TP806")
          pdata = [
            centerAlign +
              oneLineBreak +
              htmlData +
              lineBreak +
              lineBreak +
              paperCut,
          ];
        else
          pdata = [
            centerAlign + oneLineBreak + htmlData + lineBreak + paperCut,
          ];
      }

      // let config = qz.configs.create(this.state.system.printer, {
      //   units: "mm"
      // });

      // let pdata = [centerAlign + htmlData + lineBreak + paperCut];
      if (this.printSize == "A4" || this.billLogo.data[0].data == "")
        qz.print(config, pdata).then(() => {
          if (this.qrCode.print) qz.print(this.qrCode.config, this.qrCode.data);
        });
      else
        qz.print(this.billLogo.config, this.billLogo.data).then(() =>
          qz.print(config, pdata).then(() => {
            if (this.qrCode.print)
              qz.print(this.qrCode.config, this.qrCode.data);
          })
        );
      // console.log(pdata);
      // console.log(data);
      // });
      // let self = this;
      // let printerConfig = {
      //   colorType: "blackwhite",
      //   copies: 1,
      //   margins: "0",
      //   rasterize: "false",
      //   rotation: "0",
      //   scaleContent: "false",
      //   units: "mm"
      // };
      // let config = qz.configs.create(this.state.system.printer, printerConfig);
      // let options = {
      //   language: "ESCP"
      // };
      // let size = 11;
      // // Paper width 8 cm
      // let defaultStyle =
      //   "<style>* { font-size: 10px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table {width:280px;  margin-left: -70px; margin-right:0px;  } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; margin-left:-10px } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:0px !important; } tbody { display: table !important; }</style>";
      // if (this.printSize == 58) {
      //   // Paper width 5 cm
      //   size = 10;
      //   defaultStyle =
      //     "<style>* { font-size: 8px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table { width:200px;  margin-left:-80px; margin-right:5px } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:15px !important; } tbody { display: table !important; width: inherit; word-wrap: break-word; }</style>";
      // }
      // let data = [
      //   {
      //     type: "raw",
      //     format: "html",
      //     flavor: "plain", // or 'plain' if the data is raw HTML
      //     // data: this.state.billing.invoice.data.html_data,
      //     data: "<html><body>" + defaultStyle + html + "</body></html>"
      //     // data:
      //     //   '<html><body><style>* { font-size: 10px; white-space: pre-wrap; }</style><table style="border:1px solid black"><tr><td style="font-size:13px"><b><pre>Pos Store -1\n</pre></b></td></tr><tr><t d style="font-size:12px"><span><pre>D-3 Phase-II Opp Lajpat Nagar Police Station Cool School\n</pre></span></t></tr></table></body></html>'
      //   }
      // ];
      // // console.log(config);
      // qz.print(config, data)
      //   .then(function() {
      //     console.log("Sent data to printer");
      //   })
      //   .catch(function(e) {
      //     console.error(e);
      //   });
    },
    printAcknowledgement() {
      let data = {
        trans_from: this.state.system.trans_from,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        c_id: this.Invoices.c_id,
        vu_id: this.state.sessions.user.vu_id,
        operation: "BILL_REPRINT", // BILL_PRINT , BILL_REPRINT
        invoice_id: this.order_id,
        url: "/print_ack",
        terminal_id: this.state.system.settings.terminal_id,
        // security_code_vu_id: security_code_id, //Send this only on reprint
      };
      axios.post(data.url, data).then(() => {
        console.log("print ack");
      });
    },
    showPopup() {
      let rePrintPop = this.state.system.settings.print;
      var i = 0;
      for (i = 0; rePrintPop.length > i; i++) {
        if (rePrintPop[i].name == "bill_reprint") {
          if (rePrintPop[i].verify == 1) {
            this.$bvModal.show("re-print");
          } else {
            this.rePrint();
          }
        }
      }
    },
    showReturnPopup: function() {
      if (this.state.system.settings.return_authorization.status == 1) {
        this.$bvModal.show("return-item");
      } else {
        this.returnItems();
      }
    },
    returnItems() {
      let data = {
        c_id: this.Invoices.c_id,
        api_token: this.Invoices.user_api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        order_id: this.Invoices.order_id,
        trans_from: this.state.system.trans_from,
        return_request: 1,
      };
      this.$loading = true;
      this.$store
        .dispatch("billing/getReturnItem", data)
        .then(() => {
          this.$loading = false;
          this.$router.push("/return-items/");
        })
        .catch(() => (this.$loading = false));
    },
    cancelOrder() {
      this.$loading = true;
      let postData = {
        order_id: this.Invoices.order_id,
        remark: this.cancelOrderRemark,
        url: "/oms/cancel-order",
        refund_via: this.orderRefund.type,
      };
      let data = Object.assign(postData, this.essentialsData);

      axios
        .post(data.url, data)
        .then((res) => {
          // this.$loading = false;
          this.$refs["cancel-modal"].hide();
          this.$store.commit("notifications/showAlert", {
            message: res.data.message,
            type: "success",
          });
          this.$showAlert = true;
          this.fetchOrderItems();
        })
        .catch(() => (this.$loading = false));
    },
    getDepositPrint() {
      if (this.state.system.printer != "" && qz.websocket.isActive()) {
        if (this.printSize != "A4") {
          this.stringHtml =
            "<div class='webpos-print'>" +
            this.state.billing.billing.pay_balance_deposit.print_data
              .replace(
                /<size=24>|<bold>|<\/bold>|<\/size>|<normal>|<\/normal>/gi,
                ""
              )
              .replace(/<center>/gi, "<div class='cool-center'>")
              .replace(/<left>/gi, "<div class='cool-left'>")
              .replace(/<right>/gi, "<div class='cool-right'>")
              .replace(/<text>/gi, "<span>")
              .replace(/<\/text>/gi, "</span>")
              .replace(/<\/center>|<\/left>|<\/right>/gi, "</div>") +
            "</div>";
        } else {
          this.stringHtml = this.state.billing.billing.pay_balance_deposit.print_data.html;
          this.style = this.state.billing.billing.pay_balance_deposit.print_data.style;
          this.stringHtml =
            "<div class='webpos-print'><div>" +
            this.stringHtml +
            "</div></div>";
        }

        setTimeout(() => {
          this.printHtml();
        }, 1000);
      } else {
        this.html = this.state.billing.billing.pay_balance_deposit.print_html;
        this.$refs["print-invoice-modal"].show();
      }
    },
    confirmOrder(btnText) {
      if (btnText == "Confirm Order") {
        this.checkInventory();
      } else if (btnText == "Pack Order") {
        this.getOrderPackDetails();
      } else if (btnText == "Generate Invoice") {
        this.generateInvoice();
      } else if (btnText == "Print Invoice") {
        this.rePrint();
      }
    },
    takePayment(by = "o") {
      this.$loading = true;
      let postData = {
        url: "process-to-payment",
        is_payment: true,
        order_id: this.order_id,
        trans_from: "CLOUD_TAB_WEB",
        payment_by: by,
      };
      let data = Object.assign(postData, this.essentialsData);
      this.$store.commit("billing/setTransactionSubType", "order");
      this.$store
        .dispatch("billing/checkOut", data)
        .then((res) => {
          if (res.data.status == "proceed_to_payment") {
            this.$store.commit("billing/tagCustomerDetails", res.data.customer);
            this.$router.push("/checkout");
          } else if (res.data.status == "add_opening_balance") {
            this.error = true;
            this.errorMsg.text = msg.OPENING_BALANCE;
            this.errorMsg.btnText = "Continue";
            this.errorMsg.type = "session";
          }
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    flushError(val) {
      if (val == "orderUnav") this.$refs["generate-inv-unavail"].show();

      this.error = false;
      this.errorMsg = {
        btnText: "",
        text: "",
        type: "",
      };
    },
    getOrderPackDetails() {
      this.$loading = true;
      let postData = {
        url: "/oms/pack-order-details",
        order_id: this.order_id,
      };
      let data = Object.assign(postData, this.essentialsData);
      axios
        .post(data.url, data)
        .then((res) => {
          this.$loading = false;
          this.$store.commit("stock/setOrderProducts", res.data.data);
          this.$router.push("/order-packing/" + this.Invoices.order_id);
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    generateInvoice() {
      this.$loading = true;
      let postData = {
        url: "/oms/generate-invoice",
        order_id: this.order_id,
        trans_from: this.state.system.trans_from,
      };
      let data = Object.assign(postData, this.essentialsData);
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "action") {
            this.$refs["payment-model"].show();
          }
          if (res.data.status == "success") {
            let alertData = {
              message: res.data.message,
              type: "success",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
            this.fetchOrderItems();
          } else if (res.data.status == "fail" && res.data.data.length > 0) {
            this.unavailableProducts = res.data.data;
            this.error = true;
            this.errorMsg.text = msg.INV_UNAV;
            this.errorMsg.btnText = "Continue";
            this.errorMsg.type = "orderPos";
            this.errorMsg.info = " to view all the unavailable products";
          }
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    markAsFulFilled() {
      let data = Object.assign(
        {
          url: "/oms/mark-fulfilled",
          order_id: this.order_id,
        },
        this.essentialsData
      );

      axios.post(data.url, data).then((res) => {
        if (res.data.status == "success") {
          this.$store.commit("notifications/showAlert", {
            message: res.data.message,
            type: "success",
          });
          this.$showAlert = true;
          this.fetchOrderItems();
        }
      });
    },
    checkInventory() {
      let data = Object.assign(
        { order_id: this.order_id, url: "/oms/inventory-check" },
        this.essentialsData
      );

      axios.post(data.url, data).then((res) => {
        if (
          res.data.status == "success" &&
          this.checkEmpty(res.data.unavailable)
        )
          this.$refs["order-inventory-modal"].show();
        else if (
          res.data.status == "success" &&
          !this.checkEmpty(res.data.unavailable)
        )
          this.reviewConfirmOrder();
      });
    },
    reviewConfirmOrder() {
      this.$store.commit("billing/setTransactionSubType", "order");
      this.$router.push("/order-confirmation/" + this.Invoices.order_id);
    },
    confirmOrderReview() {
      let data = Object.assign(
        {
          url: "/oms/confirm-order",
          order_id: this.order_id,
          is_review: false,
        },
        this.essentialsData
      );

      axios.post(data.url, data).then((res) => {
        if (res.data.status == "success") {
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", {
            message: res.data.message,
            type: "success",
          });
          this.fetchOrderItems();
          this.$refs["order-inventory-modal"].hide();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-outline-danger {
  border-color: #ff6666;
  color: #ff6666;
}
.btn-outline-danger:hover {
  background: #ff6666;
}
.responsive-height {
  height: calc(100vh - 151px) !important;
}
.responsive-height-no-btn {
  height: calc(100vh - 111px) !important;
}
.cart-total {
  p {
    margin-bottom: 10px;
  }
  .total {
    border: 1px solid #c0c0c0;
    border-radius: 5px;
  }
}

.invoice-dtl label {
  color: #808080 !important;
}
.invoice-dtl p {
  font-size: 13px;
  color: #404040;
}
.invoice-dtl h6 {
  color: #606060;
  font-size: 0.8125rem;
}
.sale h6 {
  font-size: 0.8125rem;
  color: #606060;
}
.text-success {
  color: $success-btn !important;
}
.sale-inv-c-total {
  height: 115px;
  overflow-y: auto;
  overflow-x: hidden;
  @include custom-scrollbar();
}
#re-print p {
  color: #cc3333;
  padding-top: 13px;
}
.grey-outline-btn {
  border: 1px #808080 solid;
  background-color: transparent !important;
  color: #808080 !important;
  width: 90px;
}
.grey-outline-btn:focus:active {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.grey-outline-btn:hover {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff !important;
}
.grey-btn:hover {
  border: 1px #808080 solid;
}
.grey-btn:active {
  border: 1px #808080 solid;
}
.grey-btn {
  border: 1px #808080 solid;
  padding: 0.675rem 1rem !important;
  color: #fff;
  width: 120px !important;
}
#cool .modal-head {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
  margin-top: -14px;
  margin-left: -23px;
  margin-right: -24px;
}
.theme-dark .modal-title {
  color: #fff !important;
}
form .error {
  font-size: 0.725rem !important;
  color: #cc6666 !important;
  padding-top: 10px;
}
.print-box .center {
  text-align: center !important;
}
.print-box .left {
  text-align: left !important;
}
.print-box .right {
  text-align: right !important;
}
.modal-body .step-2 ul {
  text-align: center;
  padding: 0px;
  li {
    list-style-type: none;
    padding-bottom: 10px;
    p {
      color: #404040;
    }
  }
  li + li {
    padding-bottom: 0px;
  }
}
.theme-dark .modal-body .step-2 ul {
  li p {
    color: #c0c0c0;
  }
}
.unavailable-prod-list li {
  &:first-child {
    padding-top: 0px !important;
  }
  &:nth-child(even) {
    background: #f8f8f8 !important;
  }
}
.theme-dark .unavailable-prod-list li {
  &:nth-child(even) {
    background: #303030 !important;
  }
}
.custom-scroll {
  @include custom-scrollbar();
}
</style>
